module.exports = __webpack_public_path__ + "img/medical_banner.png?v=0c525899";